// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"15":"f346050f","290":"2fb462c3"}[chunkId] + ".chunk.js";
};